import { call } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'

export default function * requestSetUserGroupPermissionInHomeLayout (action) {
  const { layoutId, userGroupId, permissionLevel } = action.payload

  try {
    yield call(apiAction, 'SetUserGroupPermissionInHomeLayout', {
      layoutId,
      groupId: userGroupId,
      permissionLevel
    })
  } catch (error) {
    if (error.code !== 303) {
      throw error
    }
  }
}
